import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';
import { NgxInnerLoadingModule } from 'ngx-inner-loading';

import { SearchBarModule } from '../../../components/search-bar/search-bar.module';
import { PatientCellModule } from '../../routes/questions/routes/patients-list/components/patient-cell/patient-cell.module';
import { PatientSelectorComponent } from './patient-selector.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

@NgModule({
  declarations: [PatientSelectorComponent],
  imports: [
    CommonModule,
    NgxInnerLoadingModule,
    PatientCellModule,
    BsDropdownModule,
    NgxBootstrapIconsModule,
    SearchBarModule,
    PaginationModule,
    FormsModule,
    InfiniteScrollModule,
  ],
  exports: [PatientSelectorComponent],
})
export class PatientSelectorModule {}
